import React, { useState, useEffect, forwardRef, useMemo,useCallback } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Formik } from "formik";
import { Select } from "@appkit4/react-components/select";
import * as Yup from "yup";
import { handleNotificationSubmit } from "../notification/notification";
import { Modal } from "@appkit4/react-components/modal";
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
// import * as XLSX from "@e965/xlsx";
// import MaterialTable from "material-table";
// import AddBox from "@material-ui/icons/AddBox";
// import ArrowDownward from "@material-ui/icons/ArrowDownward";
// import Check from "@material-ui/icons/Check";
// import ChevronLeft from "@material-ui/icons/ChevronLeft";
// import ChevronRight from "@material-ui/icons/ChevronRight";
// import Clear from "@material-ui/icons/Clear";
// import DeleteOutline from "@material-ui/icons/DeleteOutline";
// import Edit from "@material-ui/icons/Edit";
// import FilterList from "@material-ui/icons/FilterList";
// import FirstPage from "@material-ui/icons/FirstPage";
// import LastPage from "@material-ui/icons/LastPage";
// import Remove from "@material-ui/icons/Remove";
// import SaveAlt from "@material-ui/icons/SaveAlt";
// import Search from "@material-ui/icons/Search";
// import ViewColumn from "@material-ui/icons/ViewColumn";
import PropTypes from "prop-types";
// import TextField from "@material-ui/core/TextField";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import { Button } from "@appkit4/react-components/button";

export default function ConductOnsite(props) {
  const { SelfAssessmentData, tableDataProp, wpCategoryData, handleBack } =
    props;
  // const tableIcons = {
  //   Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  //   Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  //   Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  //   Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  //   DetailPanel: forwardRef((props, ref) => (
  //     <ChevronRight {...props} ref={ref} />
  //   )),
  //   Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  //   Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  //   Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  //   FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  //   LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  //   NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  //   PreviousPage: forwardRef((props, ref) => (
  //     <ChevronLeft {...props} ref={ref} />
  //   )),
  //   ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  //   Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  //   SortArrow: forwardRef((props, ref) => (
  //     <ArrowDownward {...props} ref={ref} />
  //   )),
  //   ThirdStateCheck: forwardRef((props, ref) => (
  //     <Remove {...props} ref={ref} />
  //   )),
  //   ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  // };

  const [manager, setManager] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [tableData, setTableData] = useState(tableDataProp);
  const [responseTableData, setResponseTableData] = useState(tableDataProp);
  const [selectedType, setSelectedType] = useState(null);
  const [workProgramName, setWorkProgramName] = useState([]);
  const [wpDetails, setWPDetails] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedTemplateTable, setSelectedTemplateTable] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const { sendRequest: downloadAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: updateSelfAssessment } = useHttp();
  const { sendRequest: getWorkProgramDetailsById } = useHttp();
  const { sendRequest: getExcelTableDate } = useHttp();
  const { sendRequest: addFile } = useHttp();
  const { sendRequest: getAllFiles } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: getAllManagersList } = useHttp();
  const [gridApi, setGridApi] = useState(null);

  
  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
    // Enable filtering on all columns,
    // flex:1,
    sortable: true,
    cellDataType: false,
    wrapText: true,     
    autoHeight: true,    
  }));

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  useEffect(() => {
    getInitialDataHandler();
    getWorkPrograms();
  }, []);

  useEffect(() => {
    setTableData(tableDataProp)
  }, [tableDataProp])

  

  useEffect(() => {
    setInitialValues((oldValue) => {
      return { ...oldValue, 
        assessmentID: props.SelfAssessmentData[0].assessment_id,
        vendorName:  props.SelfAssessmentData[0].vendor_id,
        scopeOfAssessment:
           props.SelfAssessmentData[0].scopeofassessment,
        manager: props.SelfAssessmentData[0].manager,
        respondent: props.SelfAssessmentData[0].vendorrespondant,
        workProgram: props.wpCategoryData[0].workprogramid,
  }})
  }, [props.SelfAssessmentData, props.wpCategoryData])

  const [colDefs1] = useState(
    [
      {
        headerName: "Domain",
        field: "Domain",
      }, {
        headerName: "Sub Domain",
        field: "Sub Domain",
      }, {
        headerName: "Control Definition",
        field: "Control Definition",
      }, {
        headerName: "Control Testing Procedure",
        field: "Control Testing Procedure",
      },{
        headerName: "Evidence",
        field: "Evidence",
        cellRenderer: (rowData) => {
          if(rowData?.data?.Evidence_File_Content)
          {
            return rowData?.data?.Evidence ?
            (rowData?.data?.Evidence_File_Content ?
              (
                <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
              )
              : (<>{rowData?.data?.Evidence}</>))
            : (<p>No file Attachment</p>)
          }else{
           return rowData?.data?.Evidence ?
            (rowData?.data?.Evidence_File_Path ?
              (
                <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
              )
              : (<>{rowData?.data?.Evidence}</>))
            : (<p>No file Attachment</p>)
              }
        },
      },
      { headerName: "Assessor Comments", field: "Assessor Comments ",editable:true,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
        maxLength: 500
    },width:800, valueSetter: (params) => {
        const data = params.newValue ;
     
    if(data?.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)
        {
          displayToastMessage("Allowed special characters .:/,()", "error");
  
          return false;
      }else{
        params.data["Assessor Comments "]=data;
        return true;
      }
      } },
      
      {
        headerName: "Closure Status",
        field: "Closure Status",
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
            values: ['Yes', 'No','NA'],
        }
      },])
    const [colDefs2] = useState(
    [
    {
      headerName: "Area",
      field: "Area",
    },
    { headerName: "Sub Area", field: "Sub Area" },
    { headerName: "Question Id", field: "Question Id", editable: 'never' },
    { headerName: "Question",field: "Question",width:400},
    { headerName: "Instructions (If any)",field: "Instructions (If any)",width:400 },
    {
      headerName: "Evidence",
      field: "Evidence",
      editable:false,
      cellRenderer: (rowData) => {
        if(rowData?.data?.Evidence_File_Content)
        {
          return rowData?.data?.Evidence ?
          (rowData?.data?.Evidence_File_Content ?
            (
              <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
            )
            : (<>{rowData?.data?.Evidence}</>))
          : (<p>No file Attachment</p>)
        }else{
         return rowData?.data?.Evidence ?
          (rowData?.data?.Evidence_File_Path ?
            (
              <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
            )
            : (<>{rowData?.data?.Evidence}</>))
          : (<p>No file Attachment</p>)
            }
      },
    },
   
    { headerName: "Assessor Comments", field: "Assessor Comments ",editable:true,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
      maxLength: 500
  },width:800, valueSetter: (params) => {
      const data = params.newValue ;
   
  if(data?.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)
      {
        displayToastMessage("Allowed special characters .:/,()", "error");

        return false;
    }else{
      params.data["Assessor Comments "]=data;
      return true;
    }
    }
    },
    {
      headerName: "Closure Status",
      field: "Closure Status",
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorPopup: false,
      cellEditorParams: {
          values: ['Yes', 'No','NA'],
      },
  },  
    
  ]);

 

  

  const onBtnExport = () => {
    gridApi?.exportDataAsCsv();
  };

  
  const onFilterTextBoxChanged = (e)=>{
    gridApi.setQuickFilter(e.target.value);
  }


  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgramName(data.MSG)
    );
  };

  let getInitialDataHandler = async () => {
    getAllVendorList(
      APIService.getAllVendorList(),
      (result) => {
        if (result.CODE) {
          setVendors(result.MSG);
        }
      },
      (err) => {
        displayToastMessage("Something went wrong, Please try again!", "error");
      }
    );

    getAllManagersList(
      APIService.getAllManagersList(),
      (result) => {
        if (result.CODE) {
          setManager(result.MSG);
        }
      },
      errorHandler
    );
  };

  const [save, setSave] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const handleCancel = () => {
    setModalVisible(false);
  };

  
  

  const getFilesNames = async (selected) => {
    let type = "";
    setSelectedType(selected);
    if (selected === 1) {
      setTableData([]);
      type = "domain";
    } else {
      setTableData([]);
      type = "questionnaire";
    }
    getAllFiles(
      APIService.getAllFiles(type),
      (result) => {
        if (result.CODE) {
          setSelectedFiles(result.MSG);
        }
      },
      errorHandler
    );
  };

  


  const responseHandlerFile = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      getFilesNames();
    }
  };


  const getWPDetails = async (e) => {
    getWorkProgramDetailsById(
      APIService.getWorkProgramDetailsById(e, 0),
      (result) => {
        if (result.CODE) {
          setWPDetails(result.MSG[0]);
          selectedTemplates(
            JSON.parse(result.MSG[0].filename),
            result.MSG[0].workprogramcategory
          );
        }
      }
    );
  };

  const selectedTemplates = async (files, workProgramType) => {
    let fileNames = [[files], workProgramType];
    getExcelTableDate(
      APIService.getExcelTableDate(fileNames),
      (result) => {
        if (result.CODE) {
          let data;

          if (workProgramType === 1) {
            data = [...result.MSG];

            data.forEach((item) => {
              item.domainToggle = true;
              item.subDomainToggle = true;
              item.controlIDToggle = true;
            });
          } else {
            data = [...result.MSG];

            data.forEach((item) => {
              item.areaToggle = true;
              item.subAreaToggle = true;
              item.questionIDToggle = true;
            });
          }

          setSelectedTemplateTable(result.MSG);
          setTableData(result.MSG);
        }
      },
      errorHandler
    );
  };

  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    scopeOfAssessment: Yup.string()
      .required("Scope of assessment is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    workProgram: Yup.string()
      .required("Work program is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    assessmentID: Yup.number().required("Assessment ID is required"),
    manager: Yup.string()
      .required(" Third party manager is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    respondent: Yup.string()
      .required("Third party respondent is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
  });


  const handleSubmit = async (values) => {
    let jsonArray = [];

    let data = {
      flag: "update",
      paramVendorID: values.vendorName,
      paramScopeOfAssessment: values.scopeOfAssessment,
      paramVendorManager: values.manager,
      paramAssessmentID: values.assessmentID,
      paramAssessmentTypeID:
        SelfAssessmentData[0]?.assessmenttypeid,
      paramVendorRespondant: values.respondent,
      paramWorkProgramID: values.workProgram,
      paramUserID: Number(sessionStorage.getItem("userId")),
      paramCategoryData:
        SelfAssessmentData && SelfAssessmentData[0].assessmenttypeid == 4
          ? JSON.stringify(responseTableData)
          : JSON.stringify(tableData),
      paramVendorResponseStatusId: "3",
      paramVendorReviewStatusId: "3",
      paramAssessmentStatus: "Updated",
      email:sessionStorage.getItem("email"),

    };

    jsonArray.push(data);
    updateSelfAssessment(
      APIService.updateSelfAssessment(jsonArray),
      responseHandler,
      errorHandler
    );
  };

  const responseHandler = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: SelfAssessmentData && SelfAssessmentData[0].assessorid,
        paramcontent: "Conducted on-site assessment",
        paramnextroleid: 4,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: result.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
      props.handleBack();
    }
  };

  const errorHandler = () => {
    let MSG = "Something went wrong, Please try again!";
    displayToastMessage(MSG, "error");
  };

  const handleConfirm = () => {
    if (save) {
      let msg = "Request has been saved successfully";
      displayToastMessage(msg, "success");
      setModalVisible(false);
    } else {
      let msg = "Request has been submitted successfully";
      displayToastMessage(msg, "success");
      setModalVisible(false);
    }
    props.handleBack();
  };

  const saveHandler = () => {
    setModalVisible(true);
    setSave(true);
  };

  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data),
      (res) => downloadResponseHandler(res, fileName),
      (err) => {
        console.log("Error", err);
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };

  
  const onCellValueChanged = ((event) => {
    var data = event.data;
    const dataUpdate = [...tableData];
    const index = event.rowIndex;
    dataUpdate[index] = data;
    setTableData([...dataUpdate]);
  });

  const rowStyle = { background: 'white' };


  return (
    <div className="App">
      <div className="row text-end">
        <div className="col-md-12">
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={props.handleBack}
          ></span>
        </div>
      </div>
      { initialValues &&
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(prop) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          } = prop;
          return (
            <form onSubmit={handleSubmit}>
              <div className="row ">
                <div className="col-md-12">
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="IDConduct" className="cv-input-label">
                          Assessment ID <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="IDConduct"
                          type="text"
                          value={values.assessmentID}
                          onChange={handleChange("assessmentID")}
                          name="assessmentID"
                          placeholder="Please enter assessmentID"
                        />
                      </div>
                      {errors.assessmentID && touched.assessmentID && (
                        <div className="form-label error">
                          {errors.assessmentID}
                        </div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          className="cv-input-field"
                          dropdownRenderMode="portal"
                          type="email"
                          data={vendors}
                          valueKey="vendor_id"
                          labelKey="vendor_name"
                          value={values.vendorName}
                          dropdownAlwaysDown={false}
                          onSelect={(e) =>
                            handleChange("vendorName")({ target: { value: e } })
                          }
                          name="assessment"
                          placeholder="Select Third Party Name"
                        ></Select>
                      </div>
                      {errors.vendorName && touched.vendorName && (
                        <div className="form-label error">
                          {errors.vendorName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="scopeConduct" className="cv-input-label">
                          Scope of Assessment <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="scopeConduct"
                          type="text"
                          value={values.scopeOfAssessment}
                          onChange={handleChange("scopeOfAssessment")}
                          name="scope Of Assessment"
                          placeholder="Please enter scope of assessment"
                        />
                      </div>
                      {errors.scopeOfAssessment &&
                        touched.scopeOfAssessment && (
                          <div className="form-label error">
                            {errors.scopeOfAssessment}
                          </div>
                        )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Third Party Manager <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          className="cv-input-field"
                          dropdownRenderMode="portal"
                          type="email"
                          value={values.manager}
                          dropdownAlwaysDown={false}
                          data={manager}
                          valueKey="user_id"
                          labelKey="user_name"
                          onSelect={(e) =>
                            handleChange("manager")({ target: { value: e } })
                          }
                          name="assessment"
                          placeholder="Select Manager"
                        ></Select>
                      </div>
                      {errors.manager && touched.manager && (
                        <div className="form-label error">{errors.manager}</div>
                      )}
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label htmlFor="respondentConduct" className="cv-input-label">
                          Third Party respondent <span className="asterisk-required">*</span>
                        </label>
                        <input
                          className="cv-input-field"
                          onBlur={handleBlur}
                          id="respondentConduct"
                          type="text"
                          value={values.respondent}
                          onChange={handleChange("respondent")}
                          name="respondent"
                          placeholder="Please enter third party respondent"
                        />
                      </div>
                      {errors.respondent && touched.respondent && (
                        <div className="form-label error">
                          {errors.respondent}
                        </div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container pt-0 pb-0">
                        <label className="cv-input-label">
                          Work Program <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          showSearchOnToggle={true}
                          dropdownRenderMode="portal"
                          className="cv-input-field"
                          data={workProgramName}
                          dropdownAlwaysDown={false}
                          valueKey="workprogram_id"
                          labelKey="work_program_name"
                          value={values.workProgram}
                          onSelect={(e) => {
                            handleChange("workProgram")({
                              target: { value: e },
                            });
                            getWPDetails(e);
                          }}
                          name="Third Party Name"
                          placeholder="Select work program Name"
                        ></Select>
                      </div>
                      {errors.workProgram && touched.workProgram && (
                        <div className="form-label error">
                          {errors.workProgram}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row pt-5 pl-3">
                <div className="col-lg-12 mt-3 pl-1">
                  {SelfAssessmentData &&
                  SelfAssessmentData[0].assessmenttypeid == 4 ? (
                    'Commented'
                //    <MaterialTable
                //       icons={tableIcons}
                //       title="Work Program"
                //       data={responseTableData && responseTableData}
                //       columns={
                //         wpCategoryData &&
                //         wpCategoryData[0].workprogramcategory == 1
                //           ? [
                           

                //               {
                //                 title: "Domain",
                //                  field: "Domain",
                //                 editable: "never",
                //               },
                            
                //               {
                //                 title: "Sub Domain",
                //                 field: "Sub Domain",
                //                 editable: "never",
                //               },
                          
                //               {
                //                 title: "Control Definition",
                //                 field: "Control Definition",
                //                 editable: "never",
                //               },
                //               {
                //                 title: "Control Testing Procedure",
                //                 field: "Control Testing Procedure",
                //                 editable: "never",
                //               },

                //         {
                //           title: "Third Party Responses",
                //           field: "Vendor Response",
                //           editable: 'never',
                //         },
                //         {
                //           title: "Evidence",
                //           field: "Evidence",
                //           editable: 'never',
                //            render: (rowData) => {
                //               if(rowData?.data?.Evidence_File_Content)
                //               {
                //                 return rowData?.data?.Evidence ?
                //                 (rowData?.data?.Evidence_File_Content ?
                //                   (
                //                     <a href={rowData?.data?.Evidence_File_Content} download={rowData?.data?.Evidence} className="hyperText">{rowData?.data?.Evidence}</a>
                //                   )
                //                   : (<>{rowData?.data?.Evidence}</>))
                //                 : (<p>No file Attachment</p>)
                //               }else{
                //                return rowData?.data?.Evidence ?
                //                 (rowData?.data?.Evidence_File_Path ?
                //                   (
                //                     <div onClick={()=>getDownloadFile(rowData?.data?.Evidence_File_Path,rowData?.data?.Evidence)} className="hyperText">{rowData?.data?.Evidence} </div>
                //                   )
                //                   : (<>{rowData?.data?.Evidence}</>))
                //                 : (<p>No file Attachment</p>)
                //                   }
                //             },

                            
                //         },

                //         {
                //           title: "Assessor Comments",
                //           field: "Assessor Comments",
                //           editComponent: props => (
                //             <TextField
                //                 value={props.value}
                //           fullWidth={true}
                //           multiline={true}
                //           onChange={e => props.onChange(e.target.value)}
                //             />
                //         )
                //         },
                //         {
                //           title: "Closure Status",
                //           field: "Closure Status",
                //           lookup: {gap: "Gap Identified", noGap: "No Gap Identified"}
                //         },
                //       ]
                //       : [
                //         { title: "Area", field: "Area",editable: 'never', },
                //         {
                //           title: "Sub Area",
                //           field: "Sub Area",
                //         },
                //         { title: "Question Id", field: "Question Id", editable: 'never' },
                //         { title: "Question", field: "Question",editable: 'never',cellStyle: {
                //           width: 300,
                //           minWidth:300,
                //           whiteSpace:"pre-wrap"
                //           },
                //           headerStyle: {
                //           width: 300,
                //           minWidth:300
                //           }, },
                //         {
                //           title: "Instructions (If any)",
                //           field: "Instructions (If any)",
                //           editable: 'never',cellStyle: {
                //             width: 300,
                //             minWidth:300,
                //             whiteSpace:"pre-wrap"
                //             },
                //             headerStyle: {
                //             width: 300,
                //             minWidth:300
                //             },
                //         },
                //         {
                //           title: "Third Party Responses",
                //           field: "Vendor Response",
                //           editable: 'never',
                //           cellStyle: {
                //             width: 400,
                //             minWidth:400,
                //             whiteSpace: 'pre-wrap' 
                //             },
                //             headerStyle: {
                //             width: 400,
                //             minWidth:400
                //             }
                //         },
                //         {
                //           title: "Evidence",
                //           field: "Evidence",
                //           editable: 'never',
                //           render: (rowData) => {
                //             if(rowData?.Evidence_File_Content)
                //             {
                //               return rowData?.Evidence ?
                //               (rowData?.Evidence_File_Content ?
                //                 (
                //                   <a href={rowData?.Evidence_File_Content} download={rowData?.Evidence} className="hyperText">{rowData?.Evidence}</a>
                //                 )
                //                 : (<>{rowData?.Evidence}</>))
                //               : (<p>No file Attachment</p>)
                //             }else{
                //              return rowData?.Evidence ?
                //               (rowData?.Evidence_File_Path ?
                //                 (
                //                   <div onClick={()=>getDownloadFile(rowData?.Evidence_File_Path,rowData?.Evidence)} className="hyperText">{rowData?.Evidence} </div>
                //                 )
                //                 : (<>{rowData?.Evidence}</>))
                //               : (<p>No file Attachment</p>)
                //                 }
                //           },

                          
                //         },
                //         {
                //           title: "Assessor Comments",
                //           field: "Assessor Comments",
                //           cellStyle: {
                //             width: 250,
                //             minWidth:250,
                //             whiteSpace: 'pre-wrap' 
                //             },
                //             headerStyle: {
                //             width: 250,
                //             minWidth:250
                //             },
                //           editComponent: props => (
                //             <TextField
                //                 value={props.value}
                //           fullWidth={true}
                //           multiline={true}
                //           onChange={e => props.onChange(e.target.value)}
                //           error={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1}
                //           helperText={props.value&& props.value.search(/[^()0-9a-zA-Z,.:/ ]/) !== -1 ? 'Allowed special characters .:/,()' : ''}
                //             />
                //         )
                //         },
                //         {
                //           title: "Closure Status",
                //           field: "Closure Status",
                //           lookup: {gap: "Gap Identified", noGap: "No Gap Identified"}
                //         },
                //       ]
                //   }
                //   editable={{
                //     onRowUpdate: (newData, oldData) =>
                //     new Promise((resolve, reject) => {
                //       if(newData["Assessor Comments"].search(/[^()0-9a-zA-Z,.:/ ]/) !== -1)
                //           {
                //             displayToastMessage("Something went wrong, Please try again!", "error");
                //             reject();
                //           }else{
                //               setTimeout(() => {
                //                 const dataUpdate = [...tableData];
                //                 const index = oldData.tableData.id;
                //                 dataUpdate[index] = newData;
                //                 setTableData([...dataUpdate]);
                //                 resolve();
                //               }, 1000);
                //             }
                //           }),
                //   }}
                //   options={{
                //     actionsColumnIndex: -1,
                //     headerStyle: {
                //       backgroundColor: "#F2F2F2",
                //       borderTop: "1px solid #C5C5c5",
                //       color: "Black",
                //       whiteSpace: "nowrap",
                //     },
                //   }}
                // />
              ):(
                  <>
                  
                    <div className="col-lg-12  pl-1">
                    <div className="exportButton">
          <Button  className='secondaryButton removeRadius'
                            kind='secondary' onClick={() => onBtnExport()}>Export</Button>
          </div>         

          <div class="example-wrapper">
            
          <div className="searchTable">
          <span>Search:</span>
          <input
            type="text"
            id="filter-text-box"
            placeholder="search..."
            onInput={onFilterTextBoxChanged}
          />
        </div>
        </div>
                  <div class="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowData={tableData && tableData}
                            columnDefs={ wpCategoryData && wpCategoryData[0].workprogramcategory == 1?colDefs1:colDefs2}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onGridReady={onGridReady}
                            onCellValueChanged={onCellValueChanged}
                            rowStyle={rowStyle}

                          />
                        </div>
                        </div>
                        </>
                 )}
                </div>
              </div>

              <div className="options-container">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="save-button me-4"
                >
                  Submit
                </button>
                <button
                  type="submit"
                  // disabled={isSubmitting}
                  className="save-button me-4"
                  onClick={saveHandler}
                >
                  Save
                </button>
                <button
                  className="cancel-button"
                  type="reset"
                  onClick={props.handleBack}
                >
                  Cancel
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
}

      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            {save
              ? "Are you sure you want to save the Request?"
              : "Are you sure you want to submit the Request?"}
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>

            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleConfirm}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

ConductOnsite.propTypes = {
  SelfAssessmentData: PropTypes.any,
  tableDataProp: PropTypes.any,
  wpCategoryData: PropTypes.any,
  handleBack: PropTypes.any,
  sendBack: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.any
}
